// extracted by mini-css-extract-plugin
module.exports = {"offlineBanner":"offline_banner_offlineBanner__1RPMY"};